import { faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";

const UsersActionCell = (props) => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
      <ButtonGroup size="sm">
        <Button
          className="btn-green"
          onClick={(event) => {
            event.stopPropagation();
            props.onEdit();
          }}
        >
          <FontAwesomeIcon icon={faPen} size="1x" />
        </Button>

        <Button
          className="btn-red"
          onClick={(event) => {
            event.stopPropagation();
            props.onDelete();
          }}
        >
          <FontAwesomeIcon icon={faTrash} size="1x" />
        </Button>
      </ButtonGroup>
    </div>
  </Row>
);

export default UsersActionCell;
